export const load = () => ({
	title: 'Stop Window Condensation in Mid-Century Modern Home',
	showTitle: true,
});
